var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.type !== 'see')?_c('span',{staticClass:"iv-main-color iv-main-hover-color iv-operate-item iv-pull-left iv-pointer uit-add-list",on:{"click":function($event){return _vm.expandParent('edit', _vm.item)}}},[_vm._v(" 编辑 ")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }